import { ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useAddGoal } from 'features/goal/hooks';

export const BoardColumnAddGoalButton = ({
  columnId,
}: {
  columnId: string;
}) => {
  const { onAddGoalClick } = useAddGoal();

  return (
    <ButtonIcon
      aria-label="add goal"
      size="sm"
      onClick={() => onAddGoalClick(columnId)}
    >
      <Icon name={iconNames.plus} width="12px" height="12px" />
    </ButtonIcon>
  );
};
